import { GitBranch } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const GitBranchIcon = createLucideIcon(GitBranch);
